/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useMutation, useQueryClient } from '@tanstack/react-query';

import httpClient from './httpClient';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const Post = (endpoint, params) => {
  const queryClient = useQueryClient();

  const postQueryFunction = (params) => new Promise((resolve, reject) => {
    httpClient.post(`${endpoint}/`, params)
      .then(({ data }) => resolve(data))
      .catch((e) => reject(e));
  });

  return useMutation({
    mutationFn: postQueryFunction,
    // Refetch only after a successful mutation (a failed write changed nothing).
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [endpoint] }),
  });
};

export default Post;
